import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import theme from 'theme/theme';
import { WarningIcon } from './WarningIcon';
import styled from '@emotion/styled';

export const INFORMATION = 'information';
export const INFORMATION_WARNING = 'information-warning';
export const WARNING_MAJOR = 'warning-major';
export const WARNING_MODERATE = 'warning-moderate';
export const WARNING_MINOR = 'warning-minor';

type InfobarType =
  | typeof INFORMATION
  | typeof INFORMATION_WARNING
  | typeof WARNING_MAJOR
  | typeof WARNING_MODERATE
  | typeof WARNING_MINOR;

interface InfoBarInterface {
  messages?: string[];
  type: InfobarType;
  title?: string;
}

export const InfoBarTitleWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const InfoBarMessagesWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: space-evenly;
`;

export const InfoBarMessage = styled('p')`
  margin: ${(p) => p.theme.spacing(0.5)} 0px;
  font-size: 14px;
  font-weight: 400;
  color: ${(p) => p.theme.palette.grey['800']};
`;

export const InfoBarTitle = styled('h1')`
  font-size: 14px;
  font-weight: 500;
  color: ${(p) => p.theme.palette.grey['800']};
  margin-top: ${(p) => p.theme.spacing(1)};
`;

export const InfoBar = ({ title, messages, type }: InfoBarInterface) => {
  const getIcon = (type: InfobarType) => {
    switch (type) {
      case INFORMATION:
        return (
          <InfoOutlinedIcon
            style={{
              fill: theme.palette.primary.main,
              marginRight: 10,
            }}
          />
        );
      case INFORMATION_WARNING:
        return (
          <InfoOutlinedIcon
            style={{
              fill: theme.palette.error.main,
              marginRight: 10,
            }}
          />
        );
      case WARNING_MAJOR:
        return WarningIcon(theme.palette.warnings.major);
      case WARNING_MODERATE:
        return WarningIcon(theme.palette.warnings.moderate);
      case WARNING_MINOR:
        return WarningIcon(theme.palette.warnings.minor);
      default:
        return null;
    }
  };

  return (
    <>
      <InfoBarTitleWrapper>
        {getIcon(type)}
        {title && <InfoBarTitle>{title}</InfoBarTitle>}
      </InfoBarTitleWrapper>
      {messages && (
        <InfoBarMessagesWrapper>
          {messages.map((m, index) => (
            <InfoBarMessage key={index}>{m}</InfoBarMessage>
          ))}
        </InfoBarMessagesWrapper>
      )}
    </>
  );
};
